var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"items":_vm.taxRateList},model:{value:(_vm.taxRate),callback:function ($$v) {_vm.taxRate=$$v},expression:"taxRate"}})}
var staticRenderFns = []

export { render, staticRenderFns }